import React from 'react'
import moment from 'moment'
import cn from 'classnames'

function News({ className, title, news }) {
  if (!news.length) {
    return null
  }

  return (
    <div className={className}>
      <div className="card rounded-3 border-0 h-100" style={{ backgroundColor: '#13151a' }}>
        {news.map((item, index) => {
          const isFirst = index === 0
          const isLast = index === news.length - 1
          const classes = {
            'rounded-top-3': isFirst,
            'rounded-bottom-3': isLast,
            'border-bottom': (!isFirst && !isLast)
          }
          const cardStyle = !isFirst ? { backgroundColor: '#1a1d24' } : {}

          return (
            <div className={cn('card-body', classes)} key={index} style={cardStyle}>
              {isFirst && <h5 className="card-title" style={{ color: '#ECFF19' }}>
                {title}
              </h5>}
              <a href={item.url} className="text-decoration-none" target="_blank" rel="noreferrer">
                <p className={cn('card-text fw-500', { 'text-oz': isFirst, 'text-bran': !isFirst })}>
                  {item.title}
                </p>
                <p className="card-text">
                  <small className="text-grey">{moment(item.published_on * 1000).fromNow()}</small>
                </p>
              </a>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default News
